import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

export const Index = { auth: authRoles.admin, routes: [{ path: '/route-stats', component: FuseLoadable({ loader: () => import('./RouteStatsApp') }) }] };

export default [Index];
